export default "__VITE_ASSET__DU4EjZiQ__"